// Aqualung Children Gear Popup -

document.addEventListener('DOMContentLoaded', function () {

  const currentSubdomain = window.currentSubdomain;
  // Déterminer la langue ou effectuer d'autres actions en fonction du sous-domaine complet
  let currentLang;
  if (currentSubdomain.includes('uk.')) {
    currentLang = 'en';
  } else if (currentSubdomain.includes('fr.')) {
    currentLang = 'fr';
  } else if (currentSubdomain.includes('es.')) {
    currentLang = 'es';
  } else if (currentSubdomain.includes('de.') || currentSubdomain.includes('at.')) {
    currentLang = 'de';
  } else if (currentSubdomain.includes('it.')) {
    currentLang = 'it';
  } else if (currentSubdomain.includes('us.')) {
    currentLang = 'us';
  } else {
    currentLang = 'en';
  }

  const formId = {
    fr: "dc94aca9-3d6b-421d-8dd7-f7e96799d6f5",
    en: "19ca505f-4f51-42c9-a30c-d6837a5703fb",
    us: "8fa935c9-cc5d-4b11-9ed8-637f49ae41f2",
    es: "4c11e5cb-2a15-4eac-bfc3-eaebfdc1d949",
    de: "d7d22230-ba2d-4e64-b775-ec2f22c722e8",
    it: "a33f3f30-1e81-44f2-8e96-14ba40f62773"
  }

  const errorMessages = {
    fr: "Un ou plusieurs champs sont vides",
    en: "One or more fields are empty",
    us: "One or more fields are empty",
    es: "Uno o más campos están vacíos",
    de: "Einer oder mehrere Felder sind leer",
    it: "Uno o più campi sono vuoti"
  };

  const birthday = {
    fr: "Date de naissance",
    en: "Birthday",
    us: "Birthday",
    es: "Fecha de nacimiento",
    de: "Geburtstag",
    it: "Data di nascita"
  };

  const removeText = {
    fr: "Supprimer",
    en: "Remove",
    us: "Remove",
    es: "Eliminar",
    de: "Entfernen",
    it: "Rimuovi"
  };

  const addText = {
    fr: "Ajouter",
    en: "Add",
    us: "Add",
    es: "Agregar",
    de: "Hinzufügen",
    it: "Aggiungi"
  };

  // création et récupération des cookies
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  // Désactiver le bouton de soumission
  function disableSubmitButton() {
    const submitButton = document.querySelector('#hubspot-form form input[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
    }
  }

  // Création du message d'erreur / avertissement à coté du boutton soumission
  function createErrorMessageElement() {
    const form = document.querySelector('#hubspot-form form');
    const submitButton = form.querySelector('input[type="submit"]');
    const errorMessageElement = document.createElement('div');
    errorMessageElement.id = 'error-message';
    errorMessageElement.style.display = 'none';
    submitButton.parentNode.insertBefore(errorMessageElement, submitButton.nextSibling);
  }

  // Afficher ou masquer le message d'erreur 
  function showErrorMessage() {
    const errorMessageElement = document.getElementById('error-message');
    errorMessageElement.innerText = errorMessages[currentLang];
    errorMessageElement.style.display = 'block';
  }

  function hideErrorMessage() {
    const errorMessageElement = document.getElementById('error-message');
    errorMessageElement.style.display = 'none';
  }

  // Activation ou désactivation du bouton de soumission en function du resultat de areVisibleFieldsFilled()
  function checkFieldsAndToggleSubmit() {
    const form = document.querySelector('#hubspot-form form');
    const submitButton = form.querySelector('input[type="submit"]');
    const checkBox = form.querySelector('input[type="checkbox"][name="aqualung_communications"]');

    checkBox.addEventListener('click', function () {
      checkFieldsAndToggleSubmit();
    });

    if (areVisibleFieldsFilled() && checkBox.checked) {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
      hideErrorMessage();

    } else {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
      showErrorMessage();

    }
  }

  // Vérification des champs visibles pour savoir si ils sont tous remplis ou non
  function areVisibleFieldsFilled() {
    const form = document.querySelector('#hubspot-form form');
    const visibleFieldsets = Array.from(form.querySelectorAll('.form-columns-3:not(.hidden)'));
    for (const fieldset of visibleFieldsets) {
      const inputs = fieldset.querySelectorAll('input, textarea, select');
      for (const input of inputs) {
        if (!input.value.trim()) {
          return false;
        }
      }
    }
    return true;
  }

  function isFieldsetFilled(fieldset) {
    const inputs = fieldset.querySelectorAll('input, textarea, select');
    for (const input of inputs) {
      if (!input.value.trim()) {
        return false;
      }
    }
    return true;
  }

  // Reset des valeurs des champs
  function resetFieldset(fieldset) {
    const inputs = fieldset.querySelectorAll('input, textarea, select');
    for (const input of inputs) {

      input.value = '';

    }
  }

  // Ajouter les listeners aux champs contenus dans les containers form-columns-3
  function addFieldListeners() {
    const form = document.querySelector('#hubspot-form form');
    const fields = form.querySelectorAll('.form-columns-3 input, .form-columns-3 textarea, .form-columns-3 select');

    fields.forEach(field => {
      field.addEventListener('input', checkFieldsAndToggleSubmit);
    });
  }

  // Créer l'élément div pour la pop-up
  const popup = document.createElement('div');
  popup.id = 'custom-popup';
  popup.classList.add('custom-popup', 'hidden');

  // Ajouter l'élément div pour le contenu de la pop-up
  const popupContent = document.createElement('div');
  popupContent.classList.add('popup-content');
  const closeButtonContainer = document.createElement('div');
  closeButtonContainer.classList.add('close-btn-container');

  // Ajouter l'élément span pour le bouton de fermeture
  const closeButton = document.createElement('span');
  closeButton.classList.add('close-btn');
  closeButton.innerHTML = '&times;';
  closeButton.onclick = function () {
    popup.classList.add('hidden');
    sessionStorage.setItem('popupClosed', 'true');
  };

  // Ajouter le formulaire HubSpot à la pop-up
  const formContainer = document.createElement('div');
  formContainer.id = 'hubspot-form';
  popupContent.appendChild(closeButtonContainer);

  closeButtonContainer.appendChild(closeButton);
  popupContent.appendChild(formContainer);
  popup.appendChild(popupContent);
  document.body.appendChild(popup);

  // Charger le script HubSpot et créer le formulaire
  const script = document.createElement('script');
  script.charset = 'utf-8';
  script.type = 'text/javascript';
  script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
  script.onload = function () {
    hbspt.forms.create({
      region: "eu1",
      portalId: "139640702",
      formId: formId[currentLang],
      target: '#hubspot-form',
      onFormReady: function () {
        disableSubmitButton();
        createErrorMessageElement();
        addFieldListeners();
        checkFieldsAndToggleSubmit();
      },
      onFormSubmit: function () {
        setCookie('_cgsub', 'true', 365);
      }
    });
  };
  document.head.appendChild(script);

  // Ajouter les styles CSS pour la pop-up et les boutons
  const style = document.createElement('style');
  style.innerHTML = `
      .custom-popup {
            position: fixed;
            bottom: 20px;
            right: 20px;
            max-width: 360px;
            padding: 20px;
            background-color: #fff;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            z-index: 1000;
            max-height: 80vh;
            overflow-y: auto; 
            margin-left: 20px;
            font-size: 11px;
            line-height: 16px;
        }

        #custom-popup .hidden {
            display: none;
        }

        #custom-popup .disabled {
            opacity: 0.5;
            cursor: not-allowed;
            pointer-events: none;
        }

        #custom-popup .popup-content {
            position: relative;
        }

        #custom-popup .close-btn-container {
          display : flex;
          justify-content: flex-end;
          position: sticky;
          top: 0;
          z-index: 1001;
        }

        #custom-popup .close-btn {
            cursor: pointer;
            font-size: 32px;
            font-weight: 400;
            margin-right: -6px;
            margin-top: -10px;
        }

        #custom-popup .control-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
            padding: 12px 24px;
            border-radius: 2px;
            // width: 100px;
            // height: 20px;
            cursor: pointer;
            font-size: 14px;
            text-align: center;
            color: white;
        }

        #custom-popup .control-btn.add, 
        #custom-popup .control-btn.remove {
            background-color: #e6e6e6;
            color : #373631;
            transition: background-color 0.3s ease;
        }

        #custom-popup .control-btn.add:hover, 
        #custom-popup .control-btn.remove:hover {
            background-color: #dcdcdc; 
        }

        #custom-popup .control-btn.remove {
            margin-right: 10px ;
        }

        #custom-popup .control-btn.add:hover, 
        #custom-popup .control-btn.remove:hover {
            // background-color: #e6e6e6;
            // color: #373631;
        }
        
        #custom-popup .form-columns-3 {
            margin: 10px 10px 10px 0!important;
        }

         #custom-popup .form-columns-3 .hs-input {
           font-size: 14px!important;
           padding: 12px 8px;
           background-color: #f5f8fa;
        }
        
         #custom-popup .hs-form-private > fieldset:nth-of-type(2) {
            font-size: 14px!important;
          }

         #custom-popup .hs-form-private > fieldset:nth-of-type(2),
         #custom-popup .hs-form-private > fieldset:nth-of-type(10){
          margin: 10px 20px 10px 0!important;
        }

         #custom-popup .hs-form-private > fieldset:nth-of-type(10) {
          font-size: 12px!important;
        }

        #custom-popup input[type="submit"].hs-button.primary.large {
          padding: 12px 24px;
          font-size: 14px;
          line-height: 14px;
        }

       #custom-popup .hs-form-private input[type="submit"].hs-button.primary.large:hover {
          background-color: #e6e6e6!important;
          color: #000000!important;
        }
          
         #custom-popup .hs-form-private h1 {
          margin-right: 30px;
          margin-bottom: 0;
        }

         #custom-popup .hs-form-private input[type=checkbox] {
          margin-top: 2px;
          margin-right: 16px;
        }

         #custom-popup .hs-form-private input[type=checkbox]:after {
          height: 16px;
          width: 16px;
        }

        #custom-popup .input input.hs-input[type="email"] {
          width: 100%;
          background-color: #f5f8fa;
          font-size: 14px;
          padding: 12px 12px;
        }

        #custom-popup .hs-form-private h1 {
          font-size: 22px !important;
          }

        @media only screen and (max-width: 600px) {
          #custom-popup .hs-form-private h1 {
          font-size: 18px !important;
          }
        }

        @media only screen and (max-width: 400px) {
          #custom-popup .hs-form-private .hs-fieldtype-select>.input:after  {
            margin-right:22px !important;
          }

          #custom-popup .hs-form-private h1 {
            margin-bottom: 10px !important;
          }

           #custom-popup .form-columns-3 {
            margin: 10px 0!important;
            position: relative;
          }

          #custom-popup .form-columns-3::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 120px;
            height: 1px; 
            background-color: #BBBBBB; 
          }

           #custom-popup .hs-form-private .form-columns-3 .input {
            margin-bottom: 10px !important;
            }
        }
    `;
  document.head.appendChild(style);

  let popupAppeared = false;

  // Fonction pour afficher la pop-up
  function showPopup() {
    popup.classList.remove('hidden');
  }

  // Vérifier la position de défilement
  window.addEventListener('scroll', function () {
    let scrollPosition = window.scrollY || window.pageYOffset;
    const scrollThreshold = document.documentElement.scrollHeight * 0.75;
    const viewportHeight = window.innerHeight;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Ajuster la position de défilement pour inclure la hauteur visible
    const adjustedScrollPosition = scrollTop + viewportHeight;

    if (adjustedScrollPosition >= scrollThreshold && !popupAppeared && !sessionStorage.getItem('popupClosed') && !getCookie('_cgsub')) {
      showPopup();
      popupAppeared = true;
    }
  });

  // Afficher la pop-up après 10 secondes
  setTimeout(function () {
    if (!popupAppeared && !sessionStorage.getItem('popupClosed') && !getCookie('_cgsub')) {
      showPopup();
      popupAppeared = true;
    }
  }, 10000);



  // Fonction pour ajouter les boutons de contrôle
  function addControlButtons() {
    const form = document.querySelector('#hubspot-form form');
    if (!form) return;

    const children = Array.from(form.children).filter((child, index) => index >= 2 && index <= 6);
    const childrenFromEnd = form.children;
    let insertPosition = childrenFromEnd.length - 5;

    let currentVisibleIndex = -1;
    // Masquer toutes les lignes sauf la première
    for (let i = 0; i < children.length; i++) {
      if (i === 0 || isFieldsetFilled(children[i])) {
        children[i].classList.remove('hidden');
        currentVisibleIndex = i;
      } else {
        children[i].classList.add('hidden');
      }
    }

    // Ajouter les boutons de contrôle après la première ligne visible
    const controlContainer = document.createElement('div');
    controlContainer.style.display = 'flex';
    // controlContainer.style.justifyContent = 'space-between';
    controlContainer.style.marginRight = '20px';

    const addButton = document.createElement('div');
    addButton.classList.add('control-btn', 'add');
    addButton.innerHTML = addText[currentLang];

    const removeButton = document.createElement('div');
    removeButton.classList.add('control-btn', 'remove', 'hidden');
    removeButton.innerHTML = removeText[currentLang];

    form.insertBefore(controlContainer, childrenFromEnd[insertPosition]);

    controlContainer.appendChild(removeButton);
    controlContainer.appendChild(addButton);

    const dateInputDivs = document.querySelectorAll('.hs-dateinput');

    dateInputDivs.forEach(function (div) {
      // Sélectionner le premier enfant de chaque div
      const firstChild = div.querySelector('input');

      if (firstChild && firstChild.type === 'text') {
        // Changer le type de 'text' à 'date'
        firstChild.placeholder = birthday[currentLang];
      }
    });

    // Si au moins une ligne est visible, afficher le bouton de suppression
    if (currentVisibleIndex > 0) {
      removeButton.classList.remove('hidden');
    }

    // Ajouter des écouteurs d'événements pour les boutons
    addButton.addEventListener('click', function () {
      if (currentVisibleIndex + 1 < children.length) {
        currentVisibleIndex++;
        children[currentVisibleIndex].classList.remove('hidden');
        removeButton.classList.remove('hidden');
        if (currentVisibleIndex === children.length - 1) {
          addButton.classList.add('disabled');
        }
        checkFieldsAndToggleSubmit(); // Vérifiez les champs après l'ajout
      }
    });

    removeButton.addEventListener('click', function () {
      if (currentVisibleIndex > 0) {
        resetFieldset(children[currentVisibleIndex]);
        children[currentVisibleIndex].classList.add('hidden');
        addButton.classList.remove('disabled');
        currentVisibleIndex--;
        if (currentVisibleIndex === 0) {
          removeButton.classList.add('hidden');
        }
        checkFieldsAndToggleSubmit(); // Vérifiez les champs après la suppression
      }
    });
  }

  // Utiliser un MutationObserver pour détecter les changements dans le DOM et ajouter les boutons de contrôle
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.matches('#hubspot-form form')) {
            addControlButtons();
            observer.disconnect();
            break;
          }
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

